import React, { useState } from "react";
import { Button } from "@material-ui/core";
import AppleIcon from "@material-ui/icons/Apple";
import AndroidIcon from "@material-ui/icons/Android";
import MobileAppStoreMenu from "../../components/MobileAppStoreMenu/MobileAppStoreMenu";
import { ANDROID_APP_OPTIONS, IOS_APP_OPTIONS } from "../../constants/mobileApps";
import "./HomeSections.css";

const publicImg = (name) => `${process.env.PUBLIC_URL}/images/${name}`;

const ROLES = [
  {
    id: "admin",
    label: "School admin",
    heading: "Every branch, one dashboard",
    text: "School admins manage multiple branch schools from one dashboard and switch between locations instantly.",
    caption: "Multiple branches at a time",
    type: "laptop",
    image: publicImg("school-admin-branches.png"),
  },
  {
    id: "teacher",
    label: "Teacher",
    heading: "Log activities in seconds",
    text: "Teachers log activities with Quick Activity Entry, right from the classroom floor.",
    caption: "Quick Activity Entry",
    type: "phone",
    image: publicImg("teacher-app-mobile.png"),
  },
  {
    id: "parent",
    label: "Parent",
    heading: "Stay close to learning",
    text: "Parents access assignments, fees, events and progress on mobile.",
    caption: "Assignments & Events",
    type: "phone",
    image: publicImg("parent-app-menu.png"),
  },
];

// Role switcher on the left, matching device preview on the right.
const MobileApps = () => {
  const [roleIndex, setRoleIndex] = useState(0);
  const role = ROLES[roleIndex];

  return (
    <section className="hs" aria-labelledby="apps-title">
      <div className="hs__inner ma">
        <div>
          <p className="hs__eyebrow">Web, iOS and Android</p>
          <h2 className="hs__title" id="apps-title">Take MonteStory anywhere</h2>
          <p className="hs__lead">
            Run parent and child branch schools from one place. Admins switch between
            locations instantly while teachers and parents stay connected on mobile.
          </p>

          <div className="ma__roles" role="tablist" aria-label="Choose a role">
            {ROLES.map((item, index) => (
              <button
                key={item.id}
                type="button"
                role="tab"
                aria-selected={index === roleIndex}
                className={`ma__role${index === roleIndex ? " is-active" : ""}`}
                onClick={() => setRoleIndex(index)}
              >
                {item.label}
              </button>
            ))}
          </div>

          <div className="ma__detail" key={role.id}>
            <h3 className="ma__detail-title">{role.heading}</h3>
            <p className="ma__detail-text">{role.text}</p>
          </div>

          <div className="ma__stores">
            <MobileAppStoreMenu options={IOS_APP_OPTIONS}>
              <Button variant="contained" className="ma__store" startIcon={<AppleIcon />}>
                App Store
              </Button>
            </MobileAppStoreMenu>
            <MobileAppStoreMenu options={ANDROID_APP_OPTIONS}>
              <Button variant="contained" className="ma__store" startIcon={<AndroidIcon />}>
                Google Play
              </Button>
            </MobileAppStoreMenu>
          </div>
        </div>

        <div className="ma__stage" role="tabpanel">
          <figure className="ma__device" key={role.id} style={{ margin: 0 }}>
            {role.type === "laptop" ? (
              <div className="ma__laptop">
                <div className="ma__chrome">
                  <span /><span /><span />
                </div>
                <img src={role.image} alt={`${role.label} preview`} />
              </div>
            ) : (
              <div className="ma__phone">
                <img src={role.image} alt={`${role.label} app preview`} />
              </div>
            )}
            <figcaption className="ma__caption">
              <strong>{role.label}</strong>
              {role.caption}
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
};

export default MobileApps;
